import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-report-component',
  templateUrl: './report-component.component.html',
  styleUrls: ['../report.component.scss']
})
export class ReportComponentComponent {
  @Input() data: any;
}
